/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-sub-section-jwt';
const prefix = `${moduleName}.${componentName}`;

export const jwtVerifiedLabel = `${prefix}.jwtVerifiedLabel`;
export const tokenPayloadLabel = `${prefix}.tokenPayloadLabel`;

export const ENGLISH = {
    [jwtVerifiedLabel]: 'JWT Verified',
    [tokenPayloadLabel]: 'Token Payload',
};
